import { c as _c } from "react/compiler-runtime";
import { Translation } from "@/components/Translation/Translation.component";
import type { Translations } from "@/components/Translation/translation.types";
type PaywallTitleProps = {
  readonly model: Translations;
};
export function PaywallTitle(t0) {
  const $ = _c(2);
  const {
    model
  } = t0;
  let t1;
  if ($[0] !== model) {
    t1 = <h1 className="wrap-break-word hyphens-manual font-heading font-theme-heading-weight text-5xl lg:font-theme-title-weight lg:text-6xl"><Translation model={model} /></h1>;
    $[0] = model;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}